import { jsx as l, jsxs as v } from "react/jsx-runtime";
import "react";
var F = (h) => /* @__PURE__ */ v("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ...h,
  children: [
    /* @__PURE__ */ l("path", {
      fill: "#338AF3",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "M31.304 20.217H8.696c0 1.561 1.36 2.827 2.92 2.827h-.094a2.826 2.826 0 0 0 2.826 2.826 2.826 2.826 0 0 0 2.826 2.826h5.652a2.826 2.826 0 0 0 2.826-2.826 2.826 2.826 0 0 0 2.826-2.826h-.094c1.56 0 2.92-1.266 2.92-2.827Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#338AF3",
      d: "M27.826 16.522a7.826 7.826 0 0 1-15.652 0"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FFDA44",
      d: "m25.978 16.522-2.443 1.149 1.3 2.365-2.652-.507-.336 2.68L20 20.237l-1.848 1.97-.336-2.68-2.652.508 1.3-2.365-2.442-1.15 2.443-1.148-1.3-2.366 2.651.508.337-2.68L20 12.805l1.848-1.97.335 2.68 2.653-.508-1.3 2.366 2.442 1.149Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#496E2D",
      d: "M20 0a20.07 20.07 0 0 0-4.348.475L14.782 20l.87 19.525c1.4.31 2.855.475 4.348.475 11.046 0 20-8.954 20-20S31.046 0 20 0ZM5.217 6.529A19.927 19.927 0 0 0 0 19.999a19.93 19.93 0 0 0 5.218 13.472L6.088 20l-.87-13.471Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#F0F0F0",
      d: "M29.252 15.086a6.088 6.088 0 0 0-2.494-7.211 6.087 6.087 0 1 1-4.015 11.192 6.088 6.088 0 0 0 6.509-3.981Zm-5.458-7.963-.855 1.105-1.315-.472.787 1.155-.855 1.104 1.34-.39.787 1.153.042-1.396 1.341-.391-1.314-.472.042-1.396Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#F0F0F0",
      d: "m26.103 10.723-.855 1.105-1.315-.472.786 1.154-.855 1.105 1.341-.391.787 1.154.042-1.396 1.341-.391-1.314-.472.042-1.396Zm-6.379-2.289-.856 1.105-1.314-.472.786 1.155-.855 1.104 1.341-.39.787 1.153.042-1.396 1.341-.39-1.315-.473.043-1.396Zm-.094 4.124-.855 1.104-1.315-.471.786 1.154-.855 1.105 1.341-.391.787 1.154.042-1.396 1.341-.391-1.315-.472.043-1.396Zm3.924 1.408-.855 1.104-1.315-.472.786 1.155-.855 1.105 1.341-.392.787 1.155.042-1.396 1.341-.392-1.315-.471.043-1.396Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#D80027",
      d: "M5.217 6.529V33.47a19.979 19.979 0 0 0 10.435 6.053V.475A19.979 19.979 0 0 0 5.217 6.53Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#F0F0F0",
      d: "M9.2 10.53 7.452 9.229v-1.84l1.746-1.302h2.471l1.747 1.301v1.84L11.67 10.53H9.2Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FF9811",
      d: "M10.435 6.087H9.199L7.453 7.388v.9h2.982V6.087Zm0 4.443h1.235l1.747-1.301v-.94h-2.982v2.241Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#F0F0F0",
      d: "M9.2 33.913 7.452 32.61v-1.84l1.746-1.301h2.471l1.747 1.301v1.84l-1.747 1.302H9.2Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#FF9811",
      d: "M10.435 29.47H9.199l-1.746 1.3v.9h2.982v-2.2Zm0 4.443h1.235l1.747-1.301v-.94h-2.982v2.24Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#496E2D",
      d: "M9.2 22.221 7.451 20.92v-1.84L9.2 17.778h2.471l1.747 1.302v1.84l-1.747 1.301H9.2Zm4.278 2.864h-.76v-.761H11.38l-.945-.946-.946.946H8.152v.76h-.76v1.523h.76v.76H9.49l.946.946.945-.946h1.337v-.76h.761v-1.522Zm0-11.692h-.76v-.76H11.38l-.945-.946-.946.945H8.152v.761h-.76v1.522h.76v.76H9.49l.946.947.945-.946h1.337v-.761h.761v-1.522Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#D80027",
      d: "M9.565 19.13h1.74v1.74h-1.74v-1.74Zm.87-4.107a.87.87 0 1 0 0-1.739.87.87 0 0 0 0 1.74Zm0 11.692a.87.87 0 1 0 0-1.739.87.87 0 0 0 0 1.74Z"
    })
  ]
});
export {
  F as default
};
